var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-circular',{attrs:{"size":_vm.sizeBar,"width":_vm.widthBar,"value":_vm.getPercentageToday(),"color":_vm.getStatusToday()},on:{"click":_vm.showModal}},[_vm._v("\n  "+_vm._s(_vm.$store.state.countStreak)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }